module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar navbar-toggleable-sm custom-navbar"
  }, [_c('div', {
    staticClass: "navbar-brand"
  }), _vm._v(" "), _c('div', {
    staticClass: "menu-title"
  }, [_c('p', [_vm._v(_vm._s(_vm.currentApp.name))])]), _vm._v(" "), _c('div', {
    staticClass: "ml-auto menu-info"
  }, [(_vm.user !== null || _vm.user !== undefined) ? _c('span', {
    attrs: {
      "id": "greeting"
    }
  }, [_vm._v(_vm._s(_vm.GreetingMsg) + ", \n      "), (_vm.user.first_name !== null && _vm.user.last_name !== null) ? _c('span', [_vm._v(_vm._s(_vm.user.last_name) + _vm._s(_vm.user.first_name))]) : _c('span', [_vm._v(_vm._s(_vm.user.username))]), _vm._v(" "), (_vm.user.title !== null) ? _c('span', [_vm._v(_vm._s(_vm.user.title.name))]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.showLogout) ? _c('div', {
    staticClass: "logout-button",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("登出")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d88e466","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Navbar.vue
// module id = 1467
// module chunks = 1